import React, { Component } from 'react';
import {Grid, Button} from 'semantic-ui-react';
import '../../assets/css/home.css';
import FeaturedTourThumb from "./FeaturedTourThumb.js";
import {Redirect} from 'react-router';
import data from '../../assets/json/home/featuredTours.json';


export default class FeaturedTours extends Component {
	
	constructor(props){
		super(props);
		
		let defaults = this.getDefaults();
		this.state = {
			data: data.featuredtours,
			title: defaults.title,
			thumbnail: defaults.thumbnail,
			description: defaults.description,
			days: defaults.days,
			href: defaults.href,
			tourCount: Object.keys(data.featuredtours).length,
			redirect:false,
			routeLink: ''
		};

	}
	
	getDefaults = () => {
		let d = data.featuredtours;
		return d.filter((item) => item.active === 'true')[0];
	}

	onThumbnailClick = (img, index) => {
		const itemCount = this.state.tourCount;
		let d = this.state.data;
		
		for (var i = 0; i < itemCount; ++i) {
			if(i === index){
				d[i].active = "true";
			}
			else{
				d[i].active = "false";
			}
		}
				
		this.setState({
			title: img.title,
			thumbnail: img.thumbnail,
			description: img.description,
			days:img.days,
			href: img.href,
			data: d,
		});
		
	}
	goToTours = () => {
		this.setState({
			redirect: true,
			routeLink: '/tours'
		});
	}

  render() {
		const {redirect, routeLink, data} = this.state;
		return(
			<div>
				{ redirect &&
					<Redirect push to={routeLink}/>
				}
				
				<Grid className="tour-details-wrapper">
					{
						data.map(
							(img, i) => (
								<Grid.Column 
									width={6}
									className= {this.state.data[i].active === "true" ? "thumb-wrapper active" : "thumb-wrapper"} 
									key={i} 
									onClick={() => this.onThumbnailClick(img, i)}>
									<FeaturedTourThumb
										className="thumb"
										index={i}
										name={img.title}
										thumbnail={img.thumbnail}
										description={img.description}
										days={img.days}
										href={img.href}
										data={this.state.data}
									/>
									
								</Grid.Column>
							)
						)
					}
				</Grid>
				<div className="section-content-wrapper margin-top-2 align-center">
					<Button color='orange' onClick={this.goToTours}>See more tours</Button>
				</div>
			</div>
		);
	}
}